import { defineComponent as _defineComponent } from 'vue'
type PropsType = {
  text: string
  /**矩型边框颜色 */
  rectStrokeColor?: string
  /**矩型背景颜色 */
  rectFillColor?: string
  /**文字颜色 */
  textFillColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'svgTag',
  props: {
    text: null,
    rectStrokeColor: { default: '#FF2E2E' },
    rectFillColor: { default: '#ffffff' },
    textFillColor: { default: '#FF2E2E' }
  },
  setup(__props: any) {

const props = __props as { text: string, rectStrokeColor: string, rectFillColor: string, textFillColor: string };


/**
 * @description 获取字符串中的字节数
 */
const getCharLength = (str) => {
  let iLength = 0
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 255) {
      iLength += 2
    } else if (str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) {
      // 英文字母占位比小写字母和其他符号大
      iLength += 1.5
    } else {
      iLength += 1.2
    }
  }
  return iLength
}

return { __sfc: true,props, getCharLength }
}

})